'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');
var SessionContext = require('../../providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemAdditionalInfoContext = /*#__PURE__*/React__default["default"].createContext(null);
const useItemAdditionalInfo = () => {
  const context = React.useContext(ItemAdditionalInfoContext);
  if (!context) {
    throw new Error('No context provided for ItemAdditionalInfo provider');
  }
  return context;
};
const ItemAdditionalInfoProvider = _ref => {
  var _currentItemClaim$add;
  let {
    children,
    value: {
      currentItemDetails,
      currentItemClaim,
      currentClaimStep,
      claimType,
      translationsMap
    }
  } = _ref;
  const {
    handleItemClaimDetailUpdate,
    handleNavigateBack
  } = index.useClaimBuilder();
  const titan = useTitanAnalytics["default"]();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const [comment, setComment] = React.useState((currentItemClaim === null || currentItemClaim === void 0 ? void 0 : (_currentItemClaim$add = currentItemClaim.additionalInfo) === null || _currentItemClaim$add === void 0 ? void 0 : _currentItemClaim$add.comment) ?? '');
  const [confirmationChecked, setConfirmationChecked] = React.useState(false);
  const {
    fields
  } = currentClaimStep;
  let commentHelper = '';
  if (fields.comment.required) {
    commentHelper = translationsMap[claimType].helperTextRequired;
  } else {
    commentHelper = translationsMap[claimType].helperTextOptional;
  }
  const confirmationLabel = translationsMap[claimType].confirmationLabel;
  const commentLabel = translationsMap[claimType].commentLabel;
  const canProceed = (fields.comment.required ? Boolean(comment) : true) && (fields.confirmation.required ? confirmationChecked : true);
  const handleConfirmationChange = e => {
    if (e.target.checked) {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.ADDITIONAL_INFO_CHECKBOX,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_ADDITIONAL_INFO,
        page_step: useAnalytics.ClaimsPageStep.SELECTION_COMMENT,
        order_number: orderNumber,
        claim_reason: claimType
      });
    }
    setConfirmationChecked(e.target.checked);
  };
  const handleCommentChange = e => setComment(e.target.value);
  const handleSubmit = () => {
    if (!canProceed) return;
    const eventType = comment ? useAnalytics.ClaimsEventTypes.ADDITIONAL_INFO_NEXT_COMMENTED : useAnalytics.ClaimsEventTypes.ADDITIONAL_INFO_NEXT_NO_COMMENT;
    logEvent({
      event_type: eventType,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_ADDITIONAL_INFO,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_COMMENT,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handleItemClaimDetailUpdate({
      update: {
        additionalInfo: {
          comment,
          confirmationChecked
        }
      },
      step: index.ClaimStepId.ADDITIONAL_INFO
    });
    const {
      claimSteps
    } = currentItemClaim;
    const isLastStep = claimSteps[claimSteps.length - 1].id === index.ClaimStepId.ADDITIONAL_INFO;
    if (isLastStep) {
      var _currentItemClaim$pho;
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'product_added',
        properties: {
          product_id: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.itemId,
          sku: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.sku,
          name: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.name,
          extra_properties: [{
            key: 'product_quantity',
            value: `${currentItemClaim.quantity}`
          }, {
            key: 'product_additional_info_comment',
            value: comment
          }, {
            key: 'product_additional_info_confirmation',
            value: confirmationChecked ? 'true' : 'false'
          }, {
            key: 'product_number_of_photos_added',
            value: `${((_currentItemClaim$pho = currentItemClaim.photos) === null || _currentItemClaim$pho === void 0 ? void 0 : _currentItemClaim$pho.length) ?? 0}`
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    }
  };
  const handleBack = () => {
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ADDITIONAL_INFO_BACK,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_ADDITIONAL_INFO,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_COMMENT,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handleNavigateBack();
  };
  return /*#__PURE__*/React__default["default"].createElement(ItemAdditionalInfoContext.Provider, {
    value: {
      canProceed: canProceed,
      commentHelper: commentHelper,
      commentLabel,
      confirmationLabel,
      confirmationChecked: confirmationChecked,
      itemDetails: currentItemDetails,
      claimDetails: currentItemClaim,
      itemClaimStep: currentClaimStep,
      onConfirmationChange: handleConfirmationChange,
      comment: comment,
      onCommentChange: handleCommentChange,
      onSubmit: handleSubmit,
      onBack: handleBack
    }
  }, children);
};

exports.ItemAdditionalInfoContext = ItemAdditionalInfoContext;
exports.ItemAdditionalInfoProvider = ItemAdditionalInfoProvider;
exports.useItemAdditionalInfo = useItemAdditionalInfo;
